import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ConfigManager from '../../common/configManager/configManager';
import TeamNextWidget from '../../components/TeamNextWidget';
import * as types from '../../constants/index';
import { NextMatchWidgetWrapper, BetWrapper } from './styles';
import BetBar from '../../components/BetBar';

class NextMatchWidget extends Component {
  static childContextTypes = {
    breakpoints: PropTypes.arrayOf(PropTypes.number),
  };

  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      betting: 0,
    };
  }

  getChildContext = () => ({
    breakpoints: [320, 600, 1024, 1440],
  });

  componentWillMount() {
    this.loadBet();
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeCallback);
    const interval = ConfigManager.getSportRefreshInterval(this.props.sportId) ? ConfigManager.getSportRefreshInterval(this.props.sportId) : 60000;
    this.sportTimer = setInterval(this.getNextMatch, interval);
    this.getNextMatch();
    this.resizeCallback();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
    if (this.sportTimer) {
      clearInterval(this.sportTimer);
    }
  }

  getNextMatch = () => {
    const {
      sportId, teamId, actions, widgetId,
    } = this.props;
    actions.getNextMatch(sportId, teamId, widgetId);
  };

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= 1023,
    });
  };

  loadBet = () => {
    window.addEventListener('message', (e) => {
      if (e.data === 'mcQuoteTriggerAdv') {
        if (typeof window.top.matchCenterVarDfp !== 'undefined') {
          if (this.state.betting === 0) {
            //console.log('valore bet:', top.matchCenterVarDfp);
            let betType;
            if (window.top.matchCenterVarDfp === '1') {
              betType = 'sportpesa';
            } else if (window.top.matchCenterVarDfp === '2') {
              betType = 'planetwin';
            } else if (window.top.matchCenterVarDfp === '3') {
              betType = 'lottomatica';
            } else if (window.top.matchCenterVarDfp === '4') {
              betType = 'bet365';
            } else if (window.top.matchCenterVarDfp === '5') {
              betType = 'unibet';
            }
            if (process.env.REACT_APP_SITE !== 'corriere') {
              this.props.actions.getBetMatches(window.matchcenterPage.sportId, window.matchcenterPage.competitionId, betType);
              this.setState({
                betting: window.top.matchCenterVarDfp,
              });
              if (document.querySelector('.TeamHeaderWrapper')) {
                document.querySelector('.TeamHeaderWrapper').style.marginBottom = `${this.state.isMobile ? '110px' : '70px'}`;
              }
            }
          }
        }
      }
    });
  };

  render() {
    const {
      dictionary, nextMatches, actions, sportId, betMatch, widgetId,
    } = this.props;
    const { isMobile } = this.state;
    const nextMatch = nextMatches.get(widgetId);
    return (
      <NextMatchWidgetWrapper
        isMobile={isMobile}
      >
        {nextMatch &&
          <TeamNextWidget
            dictionary={dictionary}
            match={nextMatch}
            actions={actions}
            sportId={sportId}
          />
        }
        {/* {nextMatch.get('status') !== 'FULL' && betMatch && betMatch.odds && this.state.betting !== 0 && process.env.REACT_APP_SITE !== 'corriere' &&
        <BetWrapper>
          {betMatch.odds && betMatch.odds.filter(obj => obj.idMatch === `${nextMatch.getIn(['homeTeam', 'teamId'])} - ${nextMatch.getIn(['awayTeam', 'teamId'])}`) &&
          <BetBar
            isMobile
            betType={this.state.betting}
            betData={betMatch.odds.filter(obj => obj.idMatch === `${nextMatch.getIn(['homeTeam', 'teamId'])} - ${nextMatch.getIn(['awayTeam', 'teamId'])}`)}
            competitionId={window.matchcenterPage.competitionId}
          />
          }
        </BetWrapper>
        }*/}
        {nextMatch && nextMatch.status !== 'FULL' && betMatch && betMatch.odds && this.state.betting !== 0 && this.state.betting !== '4' && process.env.REACT_APP_SITE !== 'corriere' &&
        <BetWrapper>
          {betMatch.odds && betMatch.odds.filter(obj => obj.idMatch === `${nextMatch.getIn(['homeTeam', 'teamId'])} - ${nextMatch.getIn(['awayTeam', 'teamId'])}`).length > 0 &&
          <BetBar
            isMobile={isMobile}
            betType={this.state.betting}
            betData={betMatch.odds.filter(obj => obj.idMatch === `${nextMatch.getIn(['homeTeam', 'teamId'])} - ${nextMatch.getIn(['awayTeam', 'teamId'])}`)}
            competitionId={window.matchcenterPage.competitionId}
          />
          }
        </BetWrapper>
      }
        {nextMatch && nextMatch.status === 'PREMATCH' && betMatch && betMatch.odds && this.state.betting !== 0 && this.state.betting === '4' && process.env.REACT_APP_SITE !== 'corriere' &&
        <BetWrapper>
          {betMatch.odds && betMatch.odds.filter(obj => obj.idMatch === `${nextMatch.getIn(['homeTeam', 'teamId'])} - ${nextMatch.getIn(['awayTeam', 'teamId'])}`).length > 0 &&
          <BetBar
            isMobile={isMobile}
            betType={this.state.betting}
            betData={betMatch.odds.filter(obj => obj.idMatch === `${nextMatch.getIn(['homeTeam', 'teamId'])} - ${nextMatch.getIn(['awayTeam', 'teamId'])}`)}
            competitionId={window.matchcenterPage.competitionId}
          />
        }
        </BetWrapper>
      }
      </NextMatchWidgetWrapper>
    );
  }
}

NextMatchWidget.propTypes = {
  actions: PropTypes.any,
  dictionary: PropTypes.any,
  sportId: PropTypes.any,
  teamId: PropTypes.any,
  nextMatches: PropTypes.any,
  betMatch: PropTypes.any,
  widgetId: PropTypes.any,
};

export default connect(
  state => ({
    dictionary: state.dictionaryReducer.dictionary,
    nextMatches: state.sportsReducer.get('nextMatches'),
    betMatch: state.bettingReducer.betting,
  }),
  dispatch => ({
    actions: {
      initDictionary: () =>
        dispatch({ type: types.INIT_DICTIONARY }),
      getNextMatch: (sportId, teamId, widgetId) =>
        dispatch({
          type: types.GET_NEXT_MATCH_REQUEST,
          sportId,
          teamId,
          widgetId,
        }),
      favouriteGame: (sportId, matchId, currentDate) =>
        dispatch({
          type: types.FAVOURITES_MATCH,
          sportId,
          matchId,
          currentDate,
        }),
      updateFavouriteState: (matchId, widgetId) =>
        dispatch({ type: types.SET_IS_FAVOURITE, matchId, widgetId }),
      getBetMatches: (sportId, competitionId, betterName) =>
        dispatch({
          type: types.GET_BET_REQUEST,
          sportId,
          competitionId,
          betterName,
        }),
    },
  }),
)(NextMatchWidget);



// WEBPACK FOOTER //
// ./src/containers/NextMatchWidget/index.js